import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

const Privacy = () => {
  return (
    <div className="min-h-screen bg-sonas-bg text-sonas-text p-6 lg:p-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <Link to="/">
          <Button variant="ghost" className="gap-2 text-sonas-dim hover:text-sonas-text">
            <ChevronLeft size={16} /> Back to Grid
          </Button>
        </Link>
        
        <header className="space-y-4">
          <h1 className="text-5xl font-syne font-bold">Privacy Policy</h1>
          <p className="text-sonas-muted">How we protect your architectural data.</p>
        </header>

        <div className="prose prose-invert prose-sonas max-w-none">
          <h2 className="text-2xl font-bold">1. Information We Collect</h2>
          <p>To provide a secure workspace, we collect:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Authentication Data:</strong> Email address and encrypted password hashes (via Supabase).</li>
            <li><strong>Project Metadata:</strong> Titles, script content, and hierarchy scans provided by the plugin.</li>
            <li><strong>Usage Logs:</strong> Token consumption rates and model interactions for billing and optimization.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">2. How We Use Your Data</h2>
          <p>Data is used exclusively to facilitate AI generation and project management. We do not "train" global models on your private scripts. Your code remains private to your node unless you explicitly use the "Share Project" feature.</p>

          <h2 className="text-2xl font-bold mt-8">3. Third-Party Data Processing</h2>
          <p>We use industry-leading partners to provide core services:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Supabase:</strong> Database and Authentication hosting.</li>
            <li><strong>Pollinations AI:</strong> AI Inference execution.</li>
            <li><strong>SellApp:</strong> Payment processing and subscription management.</li>
          </ul>

          <h2 className="text-2xl font-bold mt-8">4. Security Measures</h2>
          <p>All data in transit is encrypted via TLS 1.3. Database storage is protected by Row Level Security (RLS), ensuring that even within our infrastructure, user data is strictly isolated between accounts.</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;